import React, { useEffect, useState } from "react";
import "./AgentHome.css";
import Sidebar from "../../../common/components/Main Menu/MainMenu";
import Spinner from "../../../common/components/Spinner/Spinner";
import Card from "react-bootstrap/Card";
import { useDispatch, useSelector } from "react-redux";
import ProgressionChart from "../../components/ProgressionChart/Progression";
import Opportunity from "../../components/Opportunity/Opportunity";
import Strength from "../../components/Strength/Strength";
import Learning from "../../components/Learning/Learning";
import { toast } from "react-toastify";
import AgentFeedbackModal from "../../../common/components/Popups/AgentFeedbackModal";
import {
  setActiveTab,
  setSelectedCard,
} from "../../../redux/slices/operationHomeSlice";
import Select from "react-select";
import {
  setAgent,
  fetchPerformanceDataInit,
  fetchInteractionInit,
} from "../../../redux/slices/agentHomeSlice";
// import Header from "../../../common/components/Header/Header";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import ContactCenter from "../../../operations/pages/OperationHome/ContactCenter";
import { UserRoles } from "../../../common/constants/constants";
import axios from "axios";
import Breadcrumb from "../../../common/components/NavigationBreadcrumb/Breadcrumb";
import { FaLink, FaEdit } from "react-icons/fa";

import TransactionPopup from "../../components/MetricsCard/TransactionPopup";
import { fetchTransactionDetailsInit } from "../../../redux/slices/agentHomeSlice";
import learningLink from "../../../assets/images/learningLink.png";
import { notify } from "../../../common/Helper/notification";
import UIConfig from "../../../common/constants/UIConfig";

const AgentHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [agentList, setAgentList] = useState([]);
  const agent = useSelector((state) => state.agentHome.agentHomeActiveAgent);
  // const [agentt, setAgent] = useState(null);
  const loading = useSelector((state) => state.agentHome.loading);
  const data = useSelector((state) => state.agentHome.performanceData);
  const requestProcessed = useSelector(
    (state) => state.agentHome.requestProcessed,
  );
  const userData = useSelector((state) => state.login);
  const userRole = userData?.login?.data?.data?.[0]?.Role;
  const [showTransactionPopup, setShowTransactionPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");

  const totalCalls = data?.totalCalls || 0;
  const totalVmCalls = data?.totalVmCalls || 0;

  const callIdsByScore = data?.callIdsByScore || {};

  const lowScoreCallIds = callIdsByScore?.low?.callIds || [];
  const mediumScoreCallIds = callIdsByScore?.medium?.callIds || [];
  const highScoreCallIds = callIdsByScore?.high?.callIds || [];

  const lowScoreCalls = lowScoreCallIds.length;
  const mediumScoreCalls = mediumScoreCallIds.length;
  const highScoreCalls = highScoreCallIds.length;

  const lowRange = callIdsByScore?.low?.range || "0 - 2.5";
  const mediumRange = callIdsByScore?.medium?.range || "2.6 - 3.5";
  const highRange = callIdsByScore?.high?.range || "3.6 - 5.0";

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Selector for Redux notification state
  const showFeedbackModalFromNotification = useSelector(
    (state) => state.notifications.notificationNavigation.showFeedbackModal,
  );

  // Sync Redux state with local modal state
  useEffect(() => {
    if (showFeedbackModalFromNotification) {
      setIsModalOpen(true);
    }
  }, [showFeedbackModalFromNotification]);

  const handleEditClick = () => {
    console.log("Edit clicked");
    setIsModalOpen(true);
  };

  console.log(userData);
  let userName;
  if (userData?.login?.data?.data?.[0]?.AgentID) {
    userName = userData?.login?.data?.data?.[0]?.FirstName;
  } else if (userData?.login?.data?.data?.[0]?.FirstName) {
    userName = userData?.login?.data?.data?.[0]?.FirstName;
  } else {
    userName = "N/A";
  }

  const location = useLocation();

  const [toastShown, setToastShown] = useState(false);

  useEffect(() => {
    if (requestProcessed && !loading && !toastShown) {
      const isEmpty =
        !data ||
        Object.keys(data || {}).length === 0 ||
        (data?.totalCalls === 0 && data?.totalVmCalls === 0);

      if (isEmpty) {
        notify.info("No data found for this agent");
        setToastShown(true);
      }
    }
  }, [location.pathname, requestProcessed, data, loading]);

  const [noOfDays, setNoOfDays] = useState(30);

  useEffect(() => {
    if (userRole && Object.values(UserRoles).includes(userRole)) {
      getAllAgents();
    }
  }, [dispatch, userRole]);

  const getAllAgents = async () => {
    try {
      const data = await axios.get(`${process.env.REACT_APP_GET_AGENT}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      if (data.status === 200) {
        console.log("Agent List: ", data.data);
        setAgentList(data.data);

        // Set the default agent to the current user if not admin
        if (userRole === "Agent") {
          const currentAgentId = userData?.login?.data?.data?.[0]?.AgentID;
          dispatch(setAgent(currentAgentId));
        } else if (data.data.length > 0) {
          // For admin, set the first agent as default
          // setAgent("A1019");
          if (!agent || agent === "")
            dispatch(setAgent(data?.data?.[0]?.AgentID));
        }
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  // Initial data fetch
  useEffect(() => {
    if (!requestProcessed && userRole === "Agent") {
      const agentId = userData?.login?.data?.data?.[0]?.AgentID || "A1019";
      const payload = { agentId: agentId };
      dispatch(fetchPerformanceDataInit(payload));
      dispatch(fetchInteractionInit("last365Days"));

      // Set the initial agent for non-agent users
      // if (userRole !== "Agent") {
      //   setAgent(agentId);
      // }
    }
  }, [dispatch, userData, requestProcessed]);

  // Fetch data when agent changes (for non-agent users)
  useEffect(() => {
    if (userRole !== "Agent" && agent) {
      console.log("Fetching data for agent:", agent); // Debug log
      dispatch(fetchPerformanceDataInit({ agentId: agent }));
      dispatch(fetchInteractionInit("last365Days"));
    }
  }, [dispatch, userRole, agent]);

  // Force re-render when data changes
  useEffect(() => {
    if (data) {
      console.log("Data updated for agent:", data); // Debug log
    }
  }, [data]);

  const handleAgentChange = (e) => {
    const selectedAgentId = e.target.value;
    dispatch(setAgent(selectedAgentId));
  };

  const handleTabClick = (tab) => {
    dispatch(setActiveTab(tab.name));
    dispatch(setSelectedCard(null));
    if (tab.name === "range" && !(tab.startDate && tab.endDate)) return;
    dispatch(fetchPerformanceDataInit(tab.name));
    dispatch(fetchInteractionInit(tab.name));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: UIConfig.branding.timeZone || "America/New_York",
    });
  };

  const lastUpdated = formatDate(data?.strengthMessage?.date);

  // Find current agent name for display
  const currentAgentName =
    agentList.find((a) => a.AgentID === agent)?.FirstName || userName;

  const agentOptions = agentList.map((a) => ({
    value: a.AgentID,
    label: `${a.FirstName} ${a.LastName || ""}`.trim(),
  }));

  const selectedAgent = agentOptions.find((o) => o.value === agent) || null;

  const breadcrumbItems = [
    { label: "Home", link: "/landing" },
    { label: "Agents Home" },
  ];

  const handleTransactionClick = (callIds, title) => {
    if (!callIds || callIds.length === 0) return;

    const payload = {
      CallIds: callIds,
      limit: 10,
      page: 1,
      sortBy: "",
      sortOrder: "",
      searchColumn: "",
      search: "",
    };

    dispatch(fetchTransactionDetailsInit(payload));
    setPopupTitle(title);
    setShowTransactionPopup(true);
  };

  return (
    <>
      {loading && <Spinner loading={loading} />}
      <div className="agent-main">
        <div className="agent-app d-flex">
          <div className="agent-header-container">
            <Navbar />
          </div>
          <div className="agent-main-container">
            {/* <Sidebar className="sidebar" /> */}
            <div className="agent-operations-home container-fluid">
              <div className="agent-home-top-bar">
                <Breadcrumb
                  breadcrumbItems={breadcrumbItems}
                  backLink="/operationHome"
                />
<div className="agent-home-top-bar-actions">
  {userRole === "Operations Manager" && (
    <div
      className="agent-btn btn-secondary"
      onClick={() => navigate("/agentGuideDashboard")}
    >
      MN Agent Guide Dashboard
    </div>
  )}
  
  <div
    className="agent-btn btn-primary"
    onClick={handleEditClick}
  >
    <span className="Agent-Feedback">Agent Feedback</span>
    <FaEdit className="edit-icon" />
  </div>
</div>
              </div>
              <div className="my-3">
                {userRole === "Agent" ? (
                  <div className="agent-welcome-container">
                    <div className="Agent-Title">Welcome, {userName}</div>
                  </div>
                ) : (
                  <div className="admin-agent-header">
                    <div className="Agent-Title">Agent: </div>
                    <div className="agent-dropdown-container">
                      <Select
                        options={agentOptions}
                        value={selectedAgent}
                        onChange={(selected) => {
                          handleAgentChange({
                            target: {
                              name: "agent-list",
                              value: selected?.value || "",
                            },
                          });
                        }}
                        placeholder={
                          agentList.length > 0
                            ? "Select agent..."
                            : "Loading agents..."
                        }
                        isLoading={agentList.length === 0}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "36px",
                            minWidth: "150px",
                            fontSize: "13px",
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: 200,
                            overflowY: "auto",
                          }),
                        }}
                      />
                    </div>

                    {/* <div className="score-card-container">
                      <div className="score-card">
                        <div className="score-range">0 - 2.5</div>

                        <div className="score-line">
                          Total Calls : {totalCalls}{" "}
                          <FaLink className="link-icon" />
                        </div>
                      </div>

                      <div className="score-card">
                        <div className="score-range">2.6 - 3.5</div>

                        <div className="score-line">
                          Total Calls : {totalCalls}{" "}
                          <FaLink className="link-icon" />
                        </div>
                      </div>

                      <div className="score-card">
                        <div className="score-range">3.6 -5.0</div>

                        <div className="score-line">
                          Total Calls : {totalCalls}{" "}
                          <FaLink className="link-icon" />
                        </div>
                      </div>
                    </div> */}
                    <div className="score-card-container">
                      {/* LOW */}
                      <div className="score-card">
                        <div className="score-card-header">
                          {lowRange}
                          {/* <FaLink
                            className="link-icon"
                            onClick={() =>
                              handleTransactionClick(
                                lowScoreCallIds,
                                "Low Score Calls",
                              )
                            }
                          /> */}
                        </div>

                        <div className="score-card-body">
                          <span>Total Calls : {lowScoreCalls}</span>
                          <img
                            src={learningLink}
                            alt="link"
                            className={`link-icon-img ${lowScoreCalls === 0 ? "disabled" : ""}`}
                            onClick={() =>
                              lowScoreCalls > 0 &&
                              handleTransactionClick(
                                lowScoreCallIds,
                                "Low Score Calls",
                              )
                            }
                          />
                        </div>
                      </div>

                      {/* MEDIUM */}
                      <div className="score-card">
                        <div className="score-card-header">
                          {mediumRange}
                          {/* <FaLink
                            className="link-icon"
                            onClick={() =>
                              handleTransactionClick(
                                mediumScoreCallIds,
                                "Medium Score Calls",
                              )
                            }
                          /> */}
                        </div>

                        <div className="score-card-body">
                          <span> Total Calls : {mediumScoreCalls}</span>
                          <img
                            src={learningLink}
                            alt="link"
                            className={`link-icon-img ${mediumScoreCalls === 0 ? "disabled" : ""}`}
                            onClick={() =>
                              mediumScoreCalls > 0 &&
                              handleTransactionClick(
                                mediumScoreCallIds,
                                "Medium Score Calls",
                              )
                            }
                          />
                        </div>
                      </div>

                      {/* HIGH */}
                      <div className="score-card">
                        <div className="score-card-header">
                          {highRange}
                          {/* <FaLink
                            className="link-icon"
                            onClick={() =>
                              handleTransactionClick(
                                highScoreCallIds,
                                "High Score Calls",
                              )
                            }
                          /> */}
                        </div>

                        <div className="score-card-body">
                          <span> Total Calls : {highScoreCalls}</span>
                          <img
                            src={learningLink}
                            alt="link"
                            className={`link-icon-img ${highScoreCalls === 0 ? "disabled" : ""}`}
                            onClick={() =>
                              highScoreCalls > 0 &&
                              handleTransactionClick(
                                highScoreCallIds,
                                "High Score Calls",
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="call_count">
                  <div>
                    <span className="astericAgent1">*</span>Contact-made Calls:{" "}
                    {totalCalls}, Voicemail Calls: {totalVmCalls} from (
                    {formatDate(data?.date)})
                  </div>
                  <div>
                    <span className="astericAgent">*</span>Analysis of Recent
                    Calls (≤100)
                  </div>
                </div>
              </div>

              <div className="Agent-container">
                <div className="row agent-container">
                  <div className="col-md-6 card-wrapper">
                    <Card className="shadow-none">
                      <Card.Body>
                        <Card.Title className="cardTitle">
                          PROGRESSION<span className="asterisk-red">*</span>
                        </Card.Title>
                        <Card.Subtitle className="shift-left">
                          Conversation Quality
                        </Card.Subtitle>
                        <ProgressionChart />
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-6 card-wrapper">
                    <Card className="shadow-none">
                      <Card.Body
                        style={{ position: "relative", width: "100%" }}
                      >
                        <Card.Title className="cardTitle">
                          MY STRENGTH*{" "}
                          <span className="myStrength-text">
                            Last Updated {lastUpdated}
                          </span>
                        </Card.Title>
                        <Card.Subtitle className="shift-left">
                          Intelligent Insights
                        </Card.Subtitle>
                        <Strength />
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-6 card-wrapper">
                    <Card className="shadow-none">
                      <Card.Body>
                        <Card.Title className="cardTitle">
                          MY OPPORTUNITY<span className="asterisk-red">*</span>
                        </Card.Title>
                        <Opportunity />
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-md-6 card-wrapper">
                    <Card className="shadow-none">
                      <Card.Body>
                        <Card.Title className="cardTitle">
                          LEARNING RESOURCE*{" "}
                          <span className="myStrength-text">
                            Last Updated {lastUpdated}
                          </span>
                        </Card.Title>
                        <Learning />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TransactionPopup
            isVisible={showTransactionPopup}
            onClose={() => setShowTransactionPopup(false)}
            recommendationCardTitle={popupTitle}
          />
        </div>
      </div>
      <AgentFeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedAgent={selectedAgent}
      />
    </>
  );
};

export default AgentHome;
